import { LoginCallback, useOktaAuth } from '@okta/okta-react';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router';

export function LoginCallbackView() {
  const [originalUri, setOriginalUri] = useState<string>('/');
  const oktaContext = useOktaAuth();
  const { authState, oktaAuth } = oktaContext;
  useEffect(() => {
    const uri = oktaAuth.getOriginalUri();
    if (uri) {
      setOriginalUri(uri);
    }
  }, [oktaAuth]);

  if (authState?.isAuthenticated) {
    return <Navigate replace to={originalUri} />;
  }
  return <LoginCallback />;
}
